import { ButtonGroup } from '@material-ui/core';
import {
  StyledSetListFiltersSection,
  StyledButton,
  StyledHeader,
  StyledTitle
} from './FilterSetsList.style';
import { SAVED_FILTER_SET_TYPES } from '@linearb/linjs-common';
import { boolPropsToClassNames } from 'common/utils/style.utils';
import { FilterIcon, ProjectIcon } from '@linearb/linui-common';
import { LBInput } from '@linearb/buzz';

const Header = ({ listFilters }) => {
  const types = [
    {
      value: SAVED_FILTER_SET_TYPES.PROJECT,
      label: 'Projects',
      Icon: ProjectIcon
    },
    {
      value: SAVED_FILTER_SET_TYPES.FILTER_SET,
      label: 'Filter Sets',
      Icon: FilterIcon
    }
  ];
  return (
    <StyledHeader>
      <StyledTitle>View and Manage Filters</StyledTitle>
      <StyledSetListFiltersSection>
        <ButtonGroup>
          {types.map(type => {
            const { Icon } = type;
            return (
              <StyledButton
                key={type.value}
                onClick={() => listFilters?.setType(type.value)}
                className={boolPropsToClassNames({
                  selected: listFilters?.type === type.value
                })}
              >
                {Icon && <Icon />}
                {type.label}
              </StyledButton>
            );
          })}
        </ButtonGroup>
        <LBInput
          name='search'
          placeholder='Search for name or owner'
          onChange={e => listFilters?.setSearchValue(e.target.value)}
          value={listFilters?.searchValue}
        />
      </StyledSetListFiltersSection>
    </StyledHeader>
  );
};

export default Header;
